import { Button } from '@limitless-minds/ui-button'
import { Paragraph } from '@limitless-minds/ui-text'
import { EmailOutlined } from '@mui/icons-material'
import { Stack, useTheme } from '@mui/material'
import React from 'react'

// TODO uncomment the following line when the email and microsoft button are implemented
//import GreyBar from '../atoms/GreyBar'
import StyledLink from '@/ui/atoms/StyledLink'

interface SignMethodProps {
  showTerms: boolean
  onGoogleClick: () => void
  onMicrosoftClick: () => void
  onEmailClick: () => void
}

// onGoogleClick and onMicrosoftClick stay in the props interface because callers already pass them,
// but the buttons that would use them are still commented out below. They are left undestructured
// rather than silenced, so the day the buttons ship the wiring is the only thing missing.
const SignMethod: React.FC<SignMethodProps> = ({ showTerms, onEmailClick }) => {
  const theme = useTheme()

  return (
    <Stack textAlign='center' gap='2rem' width='100%'>
      {
        //TODO: Uncomment the following code when the buttons functionality is implemented
      }
      {/* <Stack gap='0.75rem' width='100%'>
        <Button onClick={() => setGoogleInProgress(true)} design='ghost' startIcon={<Google />} width='100%'>
          Continue with Google
        </Button>
        {googleInProgress && <ErrorMessage>Still In Progress</ErrorMessage>}
        <Button onClick={() => setMicroInProgress(true)} design='ghost' startIcon={<Microsoft />} width='100%'>
          Continue with Microsoft
        </Button>
        {microInProgress && <ErrorMessage>still in progress</ErrorMessage>}
      </Stack>
      <Stack direction='row' width='100%' gap='0.5rem'>
        <GreyBar />
        <Paragraph variant='p16' color={theme.palette.role.onSurfaceMuted}>
          or
        </Paragraph>
        <GreyBar />
      </Stack> */}
      <Button width='100%' startIcon={<EmailOutlined />} onClick={onEmailClick}>
        {
          //TODO: change the word 'Login' for 'Continue'  when the email button functionality is implemented
        }
        {showTerms ? 'Sign Up' : 'Login'} with Email
      </Button>
      {showTerms && (
        <Paragraph variant='p16' color={theme.palette.role.onSurface}>
          By signing up, you agree to our{' '}
          <StyledLink target='_blank' to='https://limitlessminds.com/privacy-policy'>
            Privacy Policy
          </StyledLink>{' '}
          and{' '}
          <StyledLink target='_blank' to='https://limitlessminds.com/terms-and-conditions'>
            Terms & Conditions
          </StyledLink>
          .
        </Paragraph>
      )}
    </Stack>
  )
}

export default SignMethod
